export default "__VITE_ASSET__Do0B2pH3__"